export default "But like with other kinds of AI, the way that we use and design *prompts* matters a lot\n"